// removed by extract-text-webpack-plugin
module.exports = {"AuthorInfo":"AuthorInfo","authorInfo":"AuthorInfo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ContentSection/__future__/AuthorInfo.scss
// module id = 691
// module chunks = 0